// botton crea riconsegna
import {CircularProgress, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {
    AutocompleteInput,
    Button,
    FormWithRedirect,
    ReferenceInput,
    required,
    SaveButton,
    useListContext,
    useNotify,
    useUpdateMany,
} from "react-admin";
import {useToggler} from "../../shared/hooks/useToggler";
import IconCancel from "@material-ui/icons/Cancel";
import AccountTree from "@material-ui/icons/AccountTree";

export const AssociateParentDeliveryButton = () => {
  const { value, setTrue, setFalse } = useToggler();
  const notify = useNotify();

  const [updateMany, { loading }] = useUpdateMany();
  const { selectedIds } = useListContext();
  const onClick = (values: any) => {
    updateMany("deliveries", selectedIds, values, {
      onFailure: () => notify("Errore!", "error"),
      onSuccess: () => {
        notify("Fatto", "success");
        setFalse();
      },
    });
  };

  return (
    <>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          setTrue();
        }}
        label={"Missione principale"}
        title={"Rende le missioni selezionate figlie di un'altra missione"}
      >{loading ? <CircularProgress size={18} thickness={2} /> : <AccountTree />}</Button>
      <Dialog
        open={value}
        onClick={(e) => e.stopPropagation()}
        fullWidth
        maxWidth="sm"
      >
        <FormWithRedirect
          resource="project-collaborators"
          save={onClick}
          render={({ handleSubmitWithRedirect, saving }) => (
            <>
              <DialogContent>
                <ReferenceInput
                  fullWidth
                  label="Missione principale"
                  source="parent_delivery"
                  reference="autocomplete/delivery"
                  validate={[required()]}
                >
                  <AutocompleteInput optionText="label" />
                </ReferenceInput>
              </DialogContent>
              <DialogActions>
                <Button
                  label="ra.action.cancel"
                  onClick={setFalse}
                  disabled={loading}
                >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};
